import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetUserDetailsQueryVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
}>;


export type GetUserDetailsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, display_name: string, email?: string | null, phone?: string | null, avatar_url?: string | null, default_role: string, updated_at: string, created_at: string, active: boolean, customer_id?: number | null, customer?: { __typename?: 'customers', id: number, name?: string | null, organization?: { __typename?: 'organizations', id: number, name: string } | null } | null, users_usertocustomers: Array<{ __typename?: 'usertocustomers', customer_id: number, customer: { __typename?: 'customers', id: number, name?: string | null, tier: string, effective_config?: object | null, contracts: Array<{ __typename?: 'contracts', id: number, artriggers: Array<{ __typename?: 'artriggers', id: number, product_key: string }> }>, location?: { __typename?: 'locations', id: number, address_line_one?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, latitude?: number | null, longitude?: number | null, place_id?: string | null, timezone?: string | null } | null, organization?: { __typename?: 'organizations', id: number, name: string } | null } }>, users_usertofeatures: Array<{ __typename?: 'usertofeatures', id: number, feature: { __typename?: 'features', id: number, name: string, label: string } }>, users_usertoroles: Array<{ __typename?: 'usertoroles', role_id: number, roletype: { __typename?: 'roletypes', name: string } }>, driver?: { __typename?: 'drivers', id: number, status: string, config?: object | null, phone_type?: string | null, driver_app_version?: string | null, home_location?: { __typename?: 'locations', id: number, address_line_one?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, timezone?: string | null } | null, region?: { __typename?: 'regions', id: number, name: string, timezone?: string | null } | null } | null }> };


export const GetUserDetailsDocument = gql`
    query getUserDetails($userId: bigint!) {
  users(where: {id: {_eq: $userId}}) {
    id
    display_name
    email
    phone
    avatar_url
    default_role
    updated_at
    created_at
    active
    customer_id
    customer {
      id
      name
      organization {
        id
        name
      }
    }
    users_usertocustomers {
      customer_id
      customer {
        id
        name
        tier
        effective_config
        contracts(
          where: {begin_date: {_lte: "now()"}, _or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}
        ) {
          id
          artriggers {
            id
            product_key
          }
        }
        location {
          id
          address_line_one
          city
          state
          zip_code
          latitude
          longitude
          place_id
          timezone
        }
        organization {
          id
          name
        }
      }
    }
    users_usertofeatures {
      id
      feature {
        id
        name
        label
      }
    }
    users_usertoroles {
      role_id
      roletype {
        name
      }
    }
    driver {
      id
      status
      config
      phone_type
      driver_app_version
      home_location {
        id
        address_line_one
        city
        state
        zip_code
        timezone
      }
      region {
        id
        name
        timezone
      }
    }
  }
}
    `;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables> & ({ variables: GetUserDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
      }
export function useGetUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
// @ts-ignore
export function useGetUserDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export function useGetUserDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserDetailsQuery | undefined, GetUserDetailsQueryVariables>;
export function useGetUserDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUserDetailsSuspenseQuery>;
export type GetUserDetailsQueryResult = Apollo.QueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/getUserDetails.query.gql}
 */
export async function getUserDetails(
  variables: GetUserDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetUserDetailsQuery['users']>
export async function getUserDetails(
  variables: GetUserDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetUserDetailsQuery>
export async function getUserDetails(
  variables: GetUserDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetUserDetailsQuery['users'] | GetUserDetailsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetUserDetailsQuery>(
    GetUserDetailsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.users
}